import Ribbon from '../../components/Ribbon/Ribbon';
import Container from '../../components/Container/Container';
import s from './SearchPage.module.css';
import ProductCard from '../../components/ProductCard/ProductCard';
import { useState } from 'react';
import drivers from '../../JSON/drivers.json';
import NotFound from '../../views/notFound/NotFound';
// import { Link } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Input from '../../components/Input/Input';

export default function SearchPage() {
  const [query, setQuery] = useState('');
  const [searchResult, setSearchResult] = useState([]);
  const onSubmit = query => {
    setQuery(query);
    setSearchResult([]);
  };

  const onChange = event => {
    setSearchResult(event.target.value);
  };

  const normalizeContacts = query.toLowerCase();
  const filteredContacts = drivers.filter(driver =>
    driver.title.toLowerCase().includes(normalizeContacts),
  );
  return (
    <>
      <div className={s.drivers}>
        <Container>
          <section>
            <div className={s.inputDrivers}>
              <Input
                width="130%"
                top="50%"
                left="41%"
                onSubmit={onSubmit}
                onChange={onChange}
              />
            </div>
          </section>
        </Container>
      </div>
      <Ribbon />
      <div className={s.find}>
        {filteredContacts.length < 1 && <NotFound />}
        <Container>
          {query && <ProductCard products={filteredContacts} />}
        </Container>
      </div>
      <Ribbon />
      <ToastContainer
        autoClose={3000}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
}
